import { MutationTree } from "vuex";

import { ToggleMenu } from "./types";

export const mutations: MutationTree<ToggleMenu> = {
  TOGGLE_MENU(state, payload = !state.isMenuOpen) {
    state.isMenuOpen = payload;
  }
};
